
<div>
  <t-row class="permissions-table-row">
    <t-column size="" class="permissions-table-row-header row-header-selector">All relationships {{ `(${totalRelationsCount})` }}</t-column>
    <t-column
      v-for="permittee in permissionsTablePermittees"
      :key="`all_relations_${permittee.client_id}`"
      size=""
      class="enable-all"
      :data-hover="`${permittee.client_id}`"
    >
      <row>
        <input
          :id="`enable_all_relation_permissions_${permittee.client_id}`"
          type="checkbox"
          @input="toggleAllPermissionsFor(permittee)"
          :checked="allPermissionsEnabledFor(permittee)"
          :indeterminate.prop="somePermissionsEnabledFor(permittee)"
        >
        <label :for="`enable_all_relation_permissions_${permittee.client_id}`">
          All
        </label>
      </row>
    </t-column>
    <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_header_${index}`" size="">
      <row>&nbsp;</row>
    </t-column>
  </t-row>
  <t-row class="permissions-table-row">
    <t-column size="" class="permissions-table-row-header row-header-selector">Record Holders</t-column>
    <t-column
      v-for="permittee in permissionsTablePermittees"
      :key="`record_holder_relations_${permittee.client_id}`"
      size=""
      :data-hover="`${permittee.client_id}`"
    >
      <row>
        <input
          :id="`enable_edit_record_holders_permissions_${permittee.client_id}`"
          type="checkbox"
          @input="createDestroyPermission(permittee, BuiltinPermissionObjectMap[objectModelBuiltinPermission.ConnectOrSeverRecordHolder], ObjectModelPermissionCapabilityType.ConnectOrSever)"
          :checked="!!permissionFor(permittee, BuiltinPermissionObjectMap[objectModelBuiltinPermission.ConnectOrSeverRecordHolder], ObjectModelPermissionCapabilityType.ConnectOrSever)"
        >
        <label :for="`enable_edit_record_holders_permissions_${permittee.client_id}`">
          Edit Record Holder
        </label>
      </row>
    </t-column>
    <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_header_${index}`" size="">
      <row>&nbsp;</row>
    </t-column>
  </t-row>
  <template v-for="relation in allRelations">
    <relation-row
      :key="relation.client_id"
      :relation="relation"
    ></relation-row>
  </template>
</div>
